var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 0H3C1.34806 0 0.00999965 1.34735 0.00999965 3L0 14.9992C0 16.6523 1.34772 18 3 18H19C20.6523 18 22 16.6523 22 15V3C22 1.34772 20.6523 0 19 0ZM2.01 3.00083C2.01 2.44883 2.45574 2 3 2H19C19.5477 2 20 2.45228 20 3V15C20 15.5477 19.5477 16 19 16H3C2.45228 16 2 15.5477 2 15L2.01 3.00083ZM4.48406 6.00015C4.01101 5.71512 3.85859 5.10058 4.14361 4.62753C4.42864 4.15447 5.04318 4.00205 5.51623 4.28708L10.9707 7.57353L16.6632 4.14361C17.1363 3.85859 17.7517 4.01239 18.0367 4.48544C18.3211 4.95742 18.1709 5.57188 17.6998 5.85777L11.01 9.91801L11.0037 9.9284L4.48406 6.00015Z",
    fill: "#18181B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMask);
export default __webpack_public_path__ + "static/media/icon-mask.3883d87dc54205e9017533b3d2e8c843.svg";
export { ForwardRef as ReactComponent };